import { io } from "socket.io-client"

export const socket = io("https://resident-system.onrender.com", {
  transports: ["websocket"],
  withCredentials: true,
  auth: {
    token: localStorage.getItem("token"),
  },
})
